import * as React from 'react'
import { NavLink } from 'react-router-dom'

// styles and icons
import Menu from '@mui/material/Menu'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined'
import BallotIcon from '@mui/icons-material/Ballot'
import PersonOutlineIcon from '@mui/icons-material/PersonOutline'
import useStyles from './useStyles'

import { Box } from '@mui/system'

import { Drawer, IconButton, Typography } from '@mui/material'
import StepSeeDetailsSuscriber from '../Modals/RightModals/SeeDetailsSuscriber'
import { useState } from 'react'

export default function ModalMenuSuscribersOfUser ({ id, item, setLoading }) {
  const [anchorEl, setAnchorEl] = useState(null)

  const [stateDetailsSuscriber, setstateDetailsSuscriber] = useState(false)

  const open = Boolean(anchorEl)

  const handleClickIcon = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const detailsSuscriber = (anchor) => (
    <Box
      sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 800 }}
      role="presentation"
    >
      <StepSeeDetailsSuscriber
        style={{ marginTop: '5%' }}
        setstateDetailsSuscriber={setstateDetailsSuscriber}
        item={item}
        setLoading={setLoading}
      />
    </Box>
  )

  return (
    <>
      <MoreVertIcon
        sx={{
          color: '#026873',
          '&:hover': {
            color: '#00FFAC'
          }
        }}
        onClick={handleClickIcon}
      />

      <Menu
        id="basic-menu"
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <FiltersList
          id={id}
          item={item}
          setLoading={setLoading}
          onClose={handleClose}
          setstateDetailsSuscriber={setstateDetailsSuscriber}
        />
      </Menu>

      <Drawer anchor={'right'} open={stateDetailsSuscriber}>
        {detailsSuscriber('right')}
      </Drawer>
    </>
  )
}

function FiltersList ({
  id,
  item,
  setLoading,
  onClose,
  setstateDetailsSuscriber
}) {
  const classes = useStyles()
  return (
    <Box className={classes.boxStyle}>
      <IconButton
        onClick={() => {
          setstateDetailsSuscriber(true)
          onClose()
        }}
      >
        <Box className={classes.boxTypography}>
          <ErrorOutlineOutlinedIcon className={classes.hoverButtonRotate} />
          <Typography className={classes.typographyStyle}>
            Ver detalles
          </Typography>
        </Box>
      </IconButton>

      <NavLink
        to={`/subscribers/${item.subscriber_id}/suscriptions`}
        style={{ textDecoration: 'none' }}
      >
        <IconButton
          onClick={() => {
            onClose()
          }}
        >
          <Box className={classes.boxTypography}>
            <BallotIcon className={classes.hoverButton} />
            <Typography className={classes.typographyStyle}>
              Ver suscripciones y productos
            </Typography>
          </Box>
        </IconButton>
      </NavLink>

      <NavLink
        to={`/subscribers/${item.subscriber_ref_id}/users`}
        style={{ textDecoration: 'none' }}
      >
        <IconButton
          onClick={() => {
            onClose()
          }}
        >
          <Box className={classes.boxTypography}>
            <PersonOutlineIcon className={classes.hoverButton} />
            <Typography className={classes.typographyStyle}>
              Ver usuarios
            </Typography>
          </Box>
        </IconButton>
      </NavLink>
    </Box>
  )
}
